var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.menuList, function(item) {
      return !item.hidden
        ? _c("div", { key: item.name }, [
            _c(
              "a",
              {
                class: {
                  "first-menu": _vm.firstMenuNameCurrent !== item.name,
                  "first-menu-selected": _vm.firstMenuNameCurrent === item.name,
                  "first-menu-onmouseover":
                    _vm.firstMenuNameCurrent !== item.name &&
                    _vm.firstMenuNameCurrentOnmouseOver === item.name
                },
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function($event) {
                    return _vm.selectedMenu(item)
                  },
                  mousemove: function($event) {
                    return _vm.mousemoveMethod(item, 1)
                  },
                  mouseout: function($event) {
                    return _vm.mouseoutMethod(item)
                  }
                }
              },
              [
                _c("div", { staticClass: "menu-img-border" }, [
                  _c("img", {
                    staticClass: "menu-img",
                    attrs: { src: item.icon }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "menu-first": _vm.firstMenuNameCurrent !== item.name,
                        "menu-first-selected":
                          _vm.firstMenuNameCurrent === item.name,
                        "menu-first-selected-mousemove":
                          _vm.firstMenuNameCurrent !== item.name &&
                          _vm.firstMenuNameCurrentOnmouseOver === item.name
                      }
                    },
                    [_vm._v(_vm._s(item.name))]
                  )
                ]),
                _vm._v(" "),
                item.childrenList &&
                item.childrenList.length > 0 &&
                _vm.firstMenuNameCurrent !== item.name
                  ? _c("i", { staticClass: "el-icon-arrow-right" })
                  : _vm._e(),
                _vm._v(" "),
                item.childrenList &&
                item.childrenList.length > 0 &&
                _vm.firstMenuNameCurrent === item.name
                  ? _c("i", { staticClass: "el-icon-arrow-down" })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.firstMenuNameCurrent === item.name
              ? _c(
                  "div",
                  _vm._l(item.childrenList, function(secondMenu) {
                    return _c(
                      "div",
                      {
                        key: secondMenu.key,
                        class: {
                          "second-menu-border":
                            secondMenu.name !== _vm.checkedMenuCurrent,
                          "second-menu-border-selected":
                            secondMenu.name === _vm.checkedMenuCurrent,
                          "second-menu-border-mousemove":
                            secondMenu.name !== _vm.checkedMenuCurrent &&
                            _vm.secondMenuNameCurrentOnmouseOver ===
                              secondMenu.name
                        },
                        on: {
                          click: function($event) {
                            return _vm.gotoRouter(2, secondMenu)
                          },
                          mousemove: function($event) {
                            return _vm.mousemoveMethod(secondMenu, 2)
                          },
                          mouseout: function($event) {
                            return _vm.mouseoutMethod(secondMenu)
                          }
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            class: {
                              "second-menu":
                                secondMenu.name !== _vm.checkedMenuCurrent,
                              "second-menu-selected":
                                secondMenu.name === _vm.checkedMenuCurrent,
                              "second-menu-mousemove":
                                secondMenu.name !== _vm.checkedMenuCurrent &&
                                secondMenu.name ===
                                  _vm.secondMenuNameCurrentOnmouseOver
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(secondMenu.name) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ea408df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ea408df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/vidi-menu.vue
// module id = 18eV
// module chunks = 2